export const yachts = [
  {
    id: 1,
    name: "Black Watch 38ft",
    category: "Yate",
    capacity: 12,
    price: 25600,
    hours: 4,
    description: "Yate de lujo Black Watch de 38 pies, perfecto para grupos medianos que buscan elegancia y comodidad en las aguas de Los Cabos.",
    image: "https://public.readdy.ai/ai/img_res/dea520a804c220e3b92b6c57dc2c152a.jpg",
    features: ["Aire acondicionado", "Bar completo", "Equipo de snorkel", "Capitán profesional", "Seguro incluido"]
  },
  {
    id: 2,
    name: "Black Fin 32ft",
    category: "Yate",
    capacity: 10,
    price: 15000,
    hours: 4,
    description: "Embarcación deportiva Black Fin de 32 pies, ideal para pesca deportiva y paseos familiares en las hermosas aguas de Cabo.",
    image: "https://public.readdy.ai/ai/img_res/3b505825dc6fe6b07984e5809f254c67.jpg",
    features: ["Equipo de pesca", "GPS navegación", "Radio VHF", "Nevera", "Baño privado"]
  },
  {
    id: 3,
    name: "Ferretti 80ft",
    category: "Mega Yate",
    capacity: 20,
    price: 176000,
    hours: 4,
    description: "Mega yate Ferretti de 80 pies, la máxima expresión de lujo y elegancia italiana para experiencias VIP inolvidables.",
    image: "https://readdy.ai/api/search-image?query=ferretti%2080ft%20mega%20yacht%20luxury%20italian%20design%20in%20cabo%20san%20lucas%20marina%2C%20professional%20yacht%20photography%2C%20white%20luxury%20mega%20yacht%2C%20premium%20charter%20boat%2C%20elegant%20design%2C%20sophisticated%20italian%20craftsmanship%20with%20multiple%20decks&width=800&height=600&seq=ferretti80&orientation=landscape",
    features: ["Suite master", "Jacuzzi", "Chef privado", "Servicio de catering", "Tripulación completa"]
  },
  {
    id: 4,
    name: "Azimut 60ft Todo Incluido",
    category: "Yate de Lujo",
    capacity: 15,
    price: 128000,
    hours: 4,
    description: "Yate Azimut de 60 pies con paquete todo incluido, perfecto para celebraciones especiales con el máximo confort y servicio.",
    image: "https://readdy.ai/api/search-image?query=azimut%2060ft%20luxury%20yacht%20all%20inclusive%20service%20in%20cabo%20san%20lucas%2C%20professional%20marine%20photography%2C%20elegant%20white%20yacht%20design%2C%20premium%20charter%20boat%2C%20luxury%20amenities%2C%20sophisticated%20italian%20yacht%20with%20flybridge&width=800&height=600&seq=azimut60ai&orientation=landscape",
    features: ["Todo incluido", "Bebidas premium", "Comida gourmet", "Música ambiente", "Fotografía profesional"]
  },
  {
    id: 5,
    name: "Azimut 60ft",
    category: "Yate de Lujo",
    capacity: 15,
    price: 112000,
    hours: 4,
    description: "Yate Azimut de 60 pies, diseño italiano sofisticado que combina elegancia, performance y comodidad para grupos exclusivos.",
    image: "https://readdy.ai/api/search-image?query=azimut%2060ft%20luxury%20yacht%20italian%20design%20in%20cabo%20san%20lucas%20marina%2C%20professional%20yacht%20photography%2C%20sophisticated%20white%20yacht%2C%20premium%20boat%20charter%2C%20elegant%20styling%2C%20modern%20italian%20yacht%20with%20sleek%20lines&width=800&height=600&seq=azimut60&orientation=landscape",
    features: ["Diseño italiano", "Flybridge", "Camarotes privados", "Sistema de sonido", "Plataforma de natación"]
  },
  {
    id: 6,
    name: "Azimut 43ft Todo Incluido",
    category: "Yate",
    capacity: 12,
    price: 84000,
    hours: 4,
    description: "Yate Azimut de 43 pies con servicio todo incluido, ideal para grupos que buscan lujo y comodidad sin preocupaciones.",
    image: "https://readdy.ai/api/search-image?query=azimut%2043ft%20yacht%20all%20inclusive%20service%20in%20cabo%20san%20lucas%2C%20professional%20marine%20photography%2C%20elegant%20white%20yacht%20design%2C%20luxury%20charter%20boat%2C%20premium%20amenities%2C%20compact%20luxury%20yacht%20with%20modern%20features&width=800&height=600&seq=azimut43ai&orientation=landscape",
    features: ["Servicio completo", "Bar abierto", "Snacks incluidos", "Equipo acuático", "Tripulación profesional"]
  },
  {
    id: 7,
    name: "Azimut 43ft",
    category: "Yate",
    capacity: 12,
    price: 76000,
    hours: 4,
    description: "Yate Azimut de 43 pies, perfecto equilibrio entre lujo y funcionalidad para experiencias náuticas memorables.",
    image: "https://readdy.ai/api/search-image?query=azimut%2043ft%20luxury%20yacht%20italian%20craftsmanship%20in%20cabo%20san%20lucas%2C%20professional%20yacht%20photography%2C%20sleek%20white%20yacht%20design%2C%20premium%20charter%20boat%2C%20sophisticated%20styling%2C%20elegant%20italian%20yacht%20with%20modern%20amenities&width=800&height=600&seq=azimut43&orientation=landscape",
    features: ["Cabina amplia", "Cocina equipada", "Ducha exterior", "Zona de descanso", "Equipo de navegación"]
  },
  {
    id: 8,
    name: "Cabo 45ft",
    category: "Yate Deportivo",
    capacity: 14,
    price: 43200,
    hours: 4,
    description: "Yate deportivo Cabo de 45 pies, diseñado especialmente para pesca deportiva de altura con el máximo confort y seguridad.",
    image: "https://readdy.ai/api/search-image?query=cabo%2045ft%20sport%20fishing%20yacht%20in%20cabo%20san%20lucas%20marina%2C%20professional%20marine%20photography%2C%20powerful%20fishing%20yacht%20design%2C%20sport%20fishing%20boat%20charter%2C%20ocean%20background%2C%20robust%20fishing%20vessel%20with%20tower&width=800&height=600&seq=cabo45&orientation=landscape",
    features: ["Torre de pesca", "Equipo profesional", "Carnada incluida", "Outriggers", "Fish finder"]
  },
  {
    id: 9,
    name: "Cabo Life 28ft",
    category: "Lancha",
    capacity: 8,
    price: 20000,
    hours: 4,
    description: "Lancha Cabo Life de 28 pies, perfecta para familias y grupos pequeños que buscan diversión y aventura en las aguas de Cabo.",
    image: "https://readdy.ai/api/search-image?query=cabo%20life%2028ft%20family%20boat%20in%20cabo%20san%20lucas%2C%20professional%20marine%20photography%2C%20compact%20family%20yacht%20design%2C%20recreational%20boat%20charter%2C%20clear%20blue%20waters%2C%20modern%20family%20cruiser%20with%20comfortable%20seating&width=800&height=600&seq=cabolife28&orientation=landscape",
    features: ["Ideal familias", "Fácil acceso", "Toldo protección", "Equipo básico", "Seguridad máxima"]
  },
  {
    id: 10,
    name: "Golden Girl 38ft",
    category: "Yate",
    capacity: 12,
    price: 17000,
    hours: 4,
    description: "Yate Golden Girl de 38 pies, embarcación clásica con toques dorados que ofrece elegancia tradicional y confort moderno.",
    image: "https://readdy.ai/api/search-image?query=golden%20girl%2038ft%20classic%20yacht%20with%20gold%20accents%20in%20cabo%20san%20lucas%20marina%2C%20professional%20yacht%20photography%2C%20elegant%20vintage%20yacht%20design%2C%20luxury%20charter%20boat%2C%20classic%20yacht%20with%20golden%20details%20and%20traditional%20styling&width=800&height=600&seq=goldengirl38&orientation=landscape",
    features: ["Estilo clásico", "Detalles dorados", "Confort moderno", "Espacios amplios", "Tradición náutica"]
  },
  {
    id: 11,
    name: "Patron Yacht 88ft Ferretti",
    category: "Mega Yate",
    capacity: 40,
    price: 37600,
    hours: 4,
    description: "El Patron es un exquisito yate italiano Ferretti de 88 pies diseñado para aquellos que buscan el pináculo del lujo y la aventura en las impresionantes aguas de Cabo San Lucas, México.",
    image: "https://static.wixstatic.com/media/34140b_66d8dc27e9304a2fb11ac79d3ef07174~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/34140b_66d8dc27e9304a2fb11ac79d3ef07174~mv2.jpg",
    features: ["Mega yate premium", "Capacidad máxima", "Lujo extremo", "Ferretti italiano", "Experiencia única"]
  },
  {
    id: 12,
    name: "Azimut 68ft Papillon",
    category: "Mega Yate",
    capacity: 22,
    price: 220000,
    hours: 4,
    description: "Magnífico yate Azimut de 68 pies con diseño italiano elegante y amenidades de lujo. Perfecto para experiencias VIP exclusivas con flybridge espacioso y interiores de primera clase.",
    image: "https://static.wixstatic.com/media/34140b_383bc82319f942a28946fa55f2015dcd~mv2.jpg/v1/fill/w_800,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/34140b_383bc82319f942a28946fa55f2015dcd~mv2.jpg",
    features: ["Diseño Papillon", "Flybridge espacioso", "Interiores lujo", "Azimut premium", "VIP exclusivo"]
  }
];

export const yachtCategories = [
  "Todos",
  "Yate",
  "Mega Yate", 
  "Yate de Lujo",
  "Yate Deportivo",
  "Lancha"
];